import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Countries } from '../../../services/redirect.service';
import { Langs } from '../../../services/translation.service';

@Component({
  selector: 'nr-redirect-dropdown',
  templateUrl: './redirect-dropdown.component.html',
  styleUrls: ['./redirect-dropdown.component.scss'],
})
export class RedirectDropdownComponent implements OnInit {
  @Output()
  public onSelect = new EventEmitter();

  public languages = [
    // {
    //   title: 'English',
    //   value: `${Langs.English}_${Countries.Default}`,
    //   selected: false,
    // },
    {
      title: 'Россия - Русский',
      value: `${Langs.Russian}_${Countries.Russia}`,
      selected: false,
    },
    {
      title: '대한민국 – 한국어',
      value: `${Langs.Korean}_${Countries.Korea}`,
      selected: false,
    },
    {
      title: 'Korea – English',
      value: `${Langs.English}_${Countries.Korea}`,
      selected: false,
    },
  ];
  public language;

  constructor() {}

  ngOnInit(): void {
  }

  public onSelectLanguage(): void {
    this.onSelect.emit(this.language);
  }
}
